import React from 'react';
import { Zap, Mail, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#04060A] pt-16 pb-8 border-t border-white/10" data-id="element-287">
      <div className="container mx-auto px-4" data-id="element-288">
        <div className="grid md:grid-cols-2 gap-12 mb-12" data-id="element-289">
          <div data-id="element-290">
            <div className="flex items-center gap-2 mb-6" data-id="element-291">
              <Zap className="w-6 h-6 text-electric fill-electric" data-id="element-292" />
              <span className="font-bold text-xl tracking-tight" data-id="element-293">
                BIBLIOTECAS DIGITALES™
              </span>
            </div>
            <p className="text-textsecondary max-w-md mb-6" data-id="element-294">
              El sistema N°1 de autonomía eléctrica doméstica para propietarios
              argentinos.
              <br data-id="element-295" />
              <br data-id="element-296" />
              Porque resolver los problemas eléctricos de tu casa no debería
              depender de que alguien aparezca, cobre lo que quiera y no te
              explique nada.
            </p>
          </div>

          <div className="md:text-right flex flex-col md:items-end justify-center" data-id="element-297">
            <a href="mailto:soportebibliotecasdigitales@gmail.com" className="flex items-center gap-2 text-textsecondary hover:text-electric transition-colors mb-4" data-id="element-298">
              <Mail className="w-5 h-5" data-id="element-299" /> soportebibliotecasdigitales@gmail.com
            </a>
            <a href="#" className="flex items-center gap-2 text-textsecondary hover:text-electric transition-colors" data-id="element-300">
              <Globe className="w-5 h-5" data-id="element-301" /> www.bibliotecasdigitales.store
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-textsecondary/60" data-id="element-302">
          <p data-id="element-303">
            © Bibliotecas Digitales™ 2025 — Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}